import { useEffect, useState } from 'react'
import whatsapp from '../assets/whatsapp.svg'
import { track, metaTrack } from '../helpers/track'

// Barre mobile fixe « Postuler » : le formulaire vit tout en bas de pages très
// longues (~10 000 px sur l'accueil) — un candidat chaud ne doit jamais avoir
// à le chercher. Se masque quand le formulaire est déjà à l'écran.
export default function StickyApply({ isEnglish }) {
    const [visible, setVisible] = useState(false)

    useEffect(() => {
        const onScroll = () => {
            const form = document.querySelector('#contact-form')
            const nearForm = form ? form.getBoundingClientRect().top < window.innerHeight : false
            setVisible(window.scrollY > 500 && !nearForm)
        }
        window.addEventListener('scroll', onScroll, { passive: true })
        onScroll()
        return () => window.removeEventListener('scroll', onScroll)
    }, [])

    if (!visible) return null

    const goToForm = () => {
        track('sticky_apply_click')
        const form = document.querySelector('#contact-form')
        if (form) form.scrollIntoView({ behavior: 'smooth' })
        else window.location.href = '/contact'
    }

    return (
        <div className="sm:hidden fixed bottom-0 inset-x-0 z-30 p-3 bg-white/95 backdrop-blur border-t border-gray-200 flex gap-2">
            <button
                onClick={goToForm}
                className="flex-1 rounded-xl bg-gray-900 text-white py-3 text-sm font-semibold shadow-sm"
            >
                {isEnglish ? 'Apply — reply within 24h' : 'Postuler — réponse sous 24 h'}
            </button>
            <a
                href="https://wa.me/33652547516"
                target="_blank"
                rel="noreferrer"
                onClick={() => { track('whatsapp_click', { location: 'sticky' }); metaTrack('Contact') }}
                className="rounded-xl border border-gray-300 bg-white px-4 flex items-center"
            >
                <img src={whatsapp} alt="WhatsApp" className="w-6 h-6" />
            </a>
        </div>
    )
}
